import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7006Model } from '../kymw7006.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 特集候補商品一覧情報更新サービス
 * @export UpdateFeatureRequestBuyerService
 * @class UpdateFeatureRequestBuyerService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateFeatureRequestBuyerService extends PlessJsonResponderSub<any> {
  model: KYMW7006Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateFeatureRequestBuyerService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        FeatureRequestBuyers: {
          combination: this.model.updateFeatureRequestBuyer.map(_ => {
            return {
              parameter: {
                OrderCode: this.model.displaySucceededOrderCode,
                MediumType: this.model.displaySucceededMediumType,
                FeatureCode: _.featureCode,
                FeatureGoodsRequestId: _.featureGoodsRequestId,
                RequestBuyerUserId: _.requestBuyerUserId,
                UserID: this.model.loginUserId,
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateFeatureRequestBuyerService
   */
  execute(model: KYMW7006Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('updateFeatureRequestBuyer', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateFeatureRequestBuyerService
   */
  success(data: any) {
    this.model.updateFeatureRequestBuyer = [];
    if (this.calbak) this.calbak();
  }

  /**
   * API通信失敗時の処理
   */
  fault() {
    this.model.updateFeatureRequestBuyer = [];
    super.fault();
  }

  /**
   * StatusがOK以外の場合の処理
   * 独自のステータス処理を実装したい場合はこのメソッドをオーバーライドする
   *
   * @param status statauタグの値
   * @param result レスポンスの内容(rspタグの値)
   */
  protected statusError(status: string, result: any) {
    this.model.updateFeatureRequestBuyer = [];
    super.statusError(status, result);
  }
}
